"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _micRecorderToMp = _interopRequireDefault(require("mic-recorder-to-mp3"));
var _audio_timer = _interopRequireDefault(require("./audio_timer"));
var _audio_player = _interopRequireDefault(require("./audio_player"));
var _icons = require("../icons");
var _description_tooltip = _interopRequireDefault(require("./tooltips/description_tooltip"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _animations = require("../animations");
var _typography = require("../typography");
var _user_media_polyfill = _interopRequireDefault(require("../utils/user_media_polyfill"));
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @ts-expect-error - TS7016 - Could not find a declaration file for module 'mic-recorder-to-mp3'. 'node_modules/mic-recorder-to-mp3/dist/index.js' implicitly has an 'any' type.
// @ts-expect-error - TS7016 - Could not find a declaration file for module './tooltips/description_tooltip'. 'src/azalea/components/tooltips/description_tooltip.js' implicitly has an 'any' type.
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../animations'. 'src/azalea/animations/index.js' implicitly has an 'any' type.
var birchTheme = {
  buttonColor: 'transparent',
  buttonHoverColor: 'transparent',
  icon: {
    fillColor: _colors.FullPalette.EVERGREEN_700
  }
};
var AudioRecorder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AudioRecorder, _React$Component);
  var _super = _createSuper(AudioRecorder);
  function AudioRecorder(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AudioRecorder);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "requestMicrophoneAccess", function () {
      var promise = window.navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
      });

      // We've polyfilled getUserMedia to always return a promise
      // even if the browser doesn't support it
      return promise.then(function () {
        _this.setState({
          isBlocked: false
        });
        _this.startRecording();
      }, function (error) {
        _this.setState({
          isBlocked: true
        });
        console.error(error);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "startRecording", function () {
      // @ts-expect-error - TS2339 - Property 'recorder' does not exist on type 'AudioRecorder'.
      _this.recorder.start().then(function () {
        return _this.setState({
          isRecording: true
        });
      })
      // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
      ["catch"](function (error) {
        return console.error(error);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stopRecording", function () {
      // @ts-expect-error - TS2339 - Property 'recorder' does not exist on type 'AudioRecorder'.
      _this.recorder.stop().getMp3().then(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          buffer = _ref2[0],
          blob = _ref2[1];
        var file = new File(buffer, 'temp_file.mp3', {
          type: blob.type,
          lastModified: Date.now()
        });
        return _this.convertAudioToDataURL(file);
      })
      // @ts-expect-error - TS7006 - Parameter 'recordingData' implicitly has an 'any' type.
      .then(function (recordingData) {
        _this.setState({
          recordingData: recordingData,
          isRecording: false
        });
      })
      // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
      ["catch"](function (error) {
        return console.log(error);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "convertAudioToDataURL", function (inputFile) {
      var temporaryFileReader = new FileReader();
      return new Promise(function (resolve, reject) {
        temporaryFileReader.onerror = function () {
          temporaryFileReader.abort();
          reject(new DOMException('Problem parsing input file.'));
        };
        temporaryFileReader.onload = function () {
          // @ts-expect-error - TS2345 - Argument of type 'string | ArrayBuffer | null' is not assignable to parameter of type 'string | ArrayBuffer | Promise<string | ArrayBuffer>'.
          resolve(temporaryFileReader.result);
        };
        temporaryFileReader.readAsDataURL(inputFile);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDelete", function () {
      if (!_this.state.recordingData) return;
      _this.setState({
        recordingData: ''
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "disabledTooltip", function (children) {
      return /*#__PURE__*/React.createElement(_description_tooltip["default"], {
        position: "bottom",
        text: 'You must give this browser access to your microphone to record your name pronunciation'
      }, children);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isIE", function () {
      var ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    });
    (0, _user_media_polyfill["default"])();

    // @ts-expect-error - TS2339 - Property 'recorder' does not exist on type 'AudioRecorder'.
    _this.recorder = new _micRecorderToMp["default"]({
      bitRate: 92
    });
    _this.state = {
      isBlocked: false,
      isRecording: false,
      recordingData: props.recordingData
    };
    return _this;
  }
  (0, _createClass2["default"])(AudioRecorder, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        recordingData = _this$state.recordingData,
        isRecording = _this$state.isRecording,
        isBlocked = _this$state.isBlocked;
      var Icon = isRecording ? _icons.StopIcon : _icons.RecordIcon;
      if (this.isIE()) {
        return /*#__PURE__*/React.createElement(_typography.BodyText, null, "This feature is not available for your browser. Please change browsers to access recording.");
      } else if (recordingData) {
        return /*#__PURE__*/React.createElement(_audio_player["default"], {
          sourceUrl: recordingData,
          compact: false,
          deleteCallback: this.onDelete,
          fileName: this.props.recordingName
        });
      } else {
        return /*#__PURE__*/React.createElement(Wrapper, {
          onClick: isRecording ? this.stopRecording : this.requestMicrophoneAccess,
          disabled: isBlocked,
          "data-provides": "recording-wrapper"
        }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
          condition: isBlocked
          // @ts-expect-error - TS7006 - Parameter 'children' implicitly has an 'any' type.
          ,
          wrapper: function wrapper(children) {
            return _this2.disabledTooltip(children);
          }
        }, /*#__PURE__*/React.createElement(RecordButton, {
          $isRecording: isRecording,
          disabled: isBlocked,
          "data-provides": "record-button"
        }, /*#__PURE__*/React.createElement(_typography.Label, null, isRecording ? 'Stop' : 'Record'), /*#__PURE__*/React.createElement(Icon, {
          color: birchTheme.icon.fillColor
        }))), isRecording ? /*#__PURE__*/React.createElement(_audio_timer["default"], {
          onStop: this.stopRecording
        }) : /*#__PURE__*/React.createElement(RecordingLabel, null, "Record"));
      }
    }
  }]);
  return AudioRecorder;
}(React.Component); // @ts-expect-error - TS7031 - Binding element 'condition' implicitly has an 'any' type. | TS7031 - Binding element 'wrapper' implicitly has an 'any' type. | TS7031 - Binding element 'children' implicitly has an 'any' type.
var ConditionalWrapper = function ConditionalWrapper(_ref3) {
  var condition = _ref3.condition,
    wrapper = _ref3.wrapper,
    children = _ref3.children;
  return condition ? wrapper(children) : children;
};
var RecordingLabel = _styledComponents["default"].label.withConfig({
  displayName: "audio_recorder__RecordingLabel"
})(["color:", ";font-size:14px;display:inline-block;vertical-align:middle;padding:7px 15px;"], _constants.colors.darkGrey);
var RecordButton = _styledComponents["default"].div.withConfig({
  displayName: "audio_recorder__RecordButton"
})(["position:relative;background:", ";border:solid 1px ", ";width:32px;height:32px;border-radius:50%;display:inline-block;vertical-align:middle;overflow:hidden;box-shadow:0 0 0 rgba(36,164,127,0.4);will-change:box-shadow;", " ", "{display:none;}svg{display:block;position:relative;top:50%;left:50%;transform:translate(-49%,-51%);", "}"], birchTheme.buttonColor, _colors.FullPalette.EVERGREEN_700, function (props) {
  return props.$isRecording && _animations.PulseAnimation;
}, _typography.Label, function (props) {
  return props.$isRecording && (0, _styledComponents.css)(["transform:translate(-49%,-50%);"]);
});
RecordButton.displayName = 'RecordButton';
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "audio_recorder__Wrapper"
})(["cursor:pointer;", ""], function (props) {
  return props.disabled ? (0, _styledComponents.css)(["opacity:0.7;pointer-events:none;cursor:not-allowed;"]) : (0, _styledComponents.css)(["&:hover{[data-provides='record-button']{background:", ";}& > label{text-decoration:underline;}}"], birchTheme.buttonHoverColor);
});
Wrapper.displayName = 'RecordingWrapper';
var _default = exports["default"] = AudioRecorder;